export default __webpack_public_path__ + "static/ico-mail-b11728dc891c51ddd1ddbe47141924ee.svg";